import { ApiClient } from './client';
import type {
  LearningPreferences,
  OnboardingTriggerStatus,
  WelcomeOnboarding,
} from '@/types/preferences.types';

/** Shape genérico del JSON de preferences. Las subkeys pueden no estar presentes. */
export type UserPreferencesJson = Record<string, unknown> & {
  learningPreferences?: LearningPreferences;
  welcomeOnboarding?: WelcomeOnboarding;
  /** Días de la semana en que el alumno quiere estudiar (índices Date.getDay(): 0=Dom…6=Sáb). */
  studyDays?: number[];
};

export const preferencesAPI = {
  get: async (): Promise<UserPreferencesJson> => {
    return ApiClient.get<UserPreferencesJson>('/users/me/preferences');
  },

  /**
   * Merge parcial server-side. Para guardar el set de categorías mandar solo
   * `{ learningPreferences: { ...incoming } }`; el resto de prefs no se toca.
   */
  patch: async (patch: Partial<UserPreferencesJson>): Promise<UserPreferencesJson> => {
    return ApiClient.patch<UserPreferencesJson>('/users/me/preferences', patch);
  },

  getOnboardingStatus: async (): Promise<OnboardingTriggerStatus> => {
    return ApiClient.get<OnboardingTriggerStatus>('/users/me/onboarding-status');
  },
};
